var _defs, _circle, _circle2, _polyline, _polyline2, _polyline3, _polyline4, _polyline5, _polyline6, _polyline7, _polyline8, _polyline9, _polyline10, _polyline11, _polyline12, _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _ellipse, _ellipse2, _ellipse3, _path9, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffd8c9;}.cls-2{fill:#ffffff;}.cls-15,.cls-2,.cls-5,.cls-6,.cls-9{opacity:0.3;}.cls-16,.cls-17,.cls-3,.cls-4,.cls-5,.cls-6,.cls-8{fill:none;stroke-linecap:round;}.cls-3,.cls-4{stroke:#4bc190;}.cls-16,.cls-17,.cls-3,.cls-4,.cls-5,.cls-6{stroke-linejoin:round;}.cls-3,.cls-5{stroke-width:2.42px;}.cls-4,.cls-6{stroke-width:2.5px;}.cls-5,.cls-6{stroke:#356cb6;}.cls-7{fill:#4bc190;}.cls-8{stroke:#ffffff;stroke-miterlimit:10;stroke-width:4px;}.cls-17,.cls-8{opacity:0.2;}.cls-9{fill:#356cb6;}.cls-10,.cls-15{fill:#f85565;}.cls-11{fill:#8f5653;}.cls-12{fill:#b56b63;}.cls-13{fill:#db7a72;opacity:0.5;}.cls-14{fill:#393c54;}.cls-16{stroke:#393c54;}.cls-16,.cls-17{stroke-width:2px;}.cls-17{stroke:#515570;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64,
    cy: 64,
    r: 60
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 64,
    cy: 64,
    r: 48
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "38.77 76.14 42.77 79 38.77 81.86"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "38.77 60.14 42.77 63 38.77 65.86"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "38.77 44.14 42.77 47 38.77 49.86"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "46.67 29.5 47.5 34.5 42.5 33.67"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "89.53 76.14 85.53 79 89.53 81.86"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "89.53 60.14 85.53 63 89.53 65.86"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "90.53 44.14 86.53 47 90.53 49.86"
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "81.63 29.5 80.79 34.5 85.79 33.67"
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "89.53 76.14 85.53 79 89.53 81.86"
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "89.53 60.14 85.53 63 89.53 65.86"
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "90.53 44.14 86.53 47 90.53 49.86"
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "81.63 29.5 80.79 34.5 85.79 33.67"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M64,109A22,22,0,0,1,42,87V49a22,22,0,0,1,44,0V87A22,22,0,0,1,64,109Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M48,49A16,16,0,0,1,64,33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M76.27,30.73A22,22,0,0,1,80,43V74A22,22,0,0,1,45.73,92.27,22,22,0,0,0,64,102c12.15,0,22-2.85,22-15V49A22,22,0,0,0,76.27,30.73Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M63.5,21.17a3.29,3.29,0,0,0-4.88.24,3.38,3.38,0,0,0,.31,4.52l4,4a.78.78,0,0,0,1.1,0l4-4a3.38,3.38,0,0,0,.31-4.52A3.29,3.29,0,0,0,63.5,21.17Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M40,119a60,60,0,0,0,47,.45L90,93H37Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    height: 11,
    rx: 2,
    width: 62,
    x: 33,
    y: 88
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M93,88H35a2,2,0,0,0-2,2v3a2,2,0,0,1,2-2H93a2,2,0,0,1,2,2V90A2,2,0,0,0,93,88Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M71.55,66.34a1,1,0,0,1,.94,1.08,8.54,8.54,0,0,1-17,0,1,1,0,0,1,.94-1.08Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M64,69a9.08,9.08,0,0,0-6.6,2.84,8.47,8.47,0,0,0,13.2,0A9.08,9.08,0,0,0,64,69Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 53,
    cy: 63.31,
    rx: 3,
    ry: 2.02
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 75,
    cy: 63.31,
    rx: 3,
    ry: 2.02
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 75,
    cy: 58.25,
    rx: 2,
    ry: 2.02
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M57.65,57.16c-.61-2.73-2.84-2.46-5.54-1.84s-4.82,1.35-4.21,4.08a5,5,0,1,0,9.75-2.24Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 55,
    x2: 83,
    y1: 56.23,
    y2: 37.01
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 49,
    x2: 42,
    y1: 58.25,
    y2: 58.25
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 61,
    x2: 67,
    y1: 78,
    y2: 78
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar8);
export default __webpack_public_path__ + "static/media/avatar8.19b09903d9ed45e10564c67418d2546e.svg";
export { ForwardRef as ReactComponent };